import React, {useState} from "react";
import "./UseCases.scss";

// src/config/firebaseAssets.js
export const FIREBASE_BASE_URL =
    "https://firebasestorage.googleapis.com/v0/b/techadive-safiriway.firebasestorage.app/o/techadive%2Fusecases%2F";

// ✅ Helper to build image URLs
export const firebaseImage = (filename, token) =>
    `${FIREBASE_BASE_URL}${encodeURIComponent(filename)}?alt=media&token=${token}`;


// Usage:
export const ecomImage = firebaseImage("ecommerce.webp", "29abf036-83d4-4c4a-b21f-3390c8c38b92");
export const fintechImage = firebaseImage("fintech.webp", "e498ae5a-11aa-4691-965e-5d14bd8b0ee3");
export const enterpriseImage = firebaseImage("enterprise.webp", "fa3d4aa4-244a-4672-9d2d-dac8b2309399");
export const mobilityImage = firebaseImage("tech_mobility.webp", "4d20d907-3bc0-4e99-9c92-5723d9af407f");

const UseCases = () => {
    const cases = [
        {
            title: "E-commerce & Retail",
            desc: "Building digital stores, inventory systems, and seamless online experiences for global retailers.",
            image: ecomImage,
        },
        {
            title: "Fintech & Banking",
            desc: "Secure, scalable financial platforms empowering online payments, banking, and digital wallets.",
            image: fintechImage,
        },
        {
            title: "Enterprise Platforms",
            desc: "Developing secure, efficient, and citizen-focused platforms for government and public institutions.",
            image: enterpriseImage, // update this image import
        },
        {
            title: "Tech-Mobility",
            desc: "Smart mobility and automotive solutions, from connected apps to real-time vehicle data systems.",
            image: mobilityImage,
        },
    ];

    return (
        <section className="use-cases" id="use-cases">
            <h2>Where Our Technology Makes an Impact</h2>
            <p>From startups to enterprises, our solutions power real-world systems — from connected IoT devices and automation tools to scalable digital platforms. Here’s how we help businesses innovate across industries.</p>
            <div className="use-cases__grid">
                {cases.map((c, i) => (
                    <ImageCard key={i} title={c.title} desc={c.desc} image={c.image} />
                ))}
            </div>
        </section>
    );
};

const ImageCard = ({ title, desc, image }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className="case-card">
            {!loaded && <div className="skeleton" />} {/* Skeleton while loading */}

            <img
                src={image}
                alt={title}
                style={{ display: loaded ? "block" : "none" }}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)} // fallback to avoid stuck skeletons
            />

            <div className="gradient-overlay" />
            <div className="case-content">
                <h3>{title}</h3>
                <div className="divider"></div>
                <p>{desc}</p>
            </div>
        </div>
    );
};

export default UseCases;
